import { EventEmitter, Output, Directive } from '@angular/core';
@Directive()
export abstract class BotaoBase
{
    @Output() clique = new EventEmitter<any>();   
    public onClique(data)
    {
        this.clique.emit(data)
    }    
}